export const PAX_OPTS = [{ value: 'adult', label: '성인' }, { value: 'child', label: '소아' }, { value: 'infant', label: '유아' }];
export const STATUS_OPTS = [{ value: 'confirmed', label: '확정' }, { value: 'cancelled', label: '취소' }, { value: 'completed', label: '완료' }];
export const YN_OPTS = [{ value: 'true', label: '예' }, { value: 'false', label: '아니오' }];
export const PAYMENT_METHOD_OPTS = [
  { value: 'cash', label: '현금' },
  { value: 'card', label: '카드' },
];

export const FIELD_DEFS = [
  { key: 'travel_code', label: '여행코드', group: '예약 마스터', alwaysVisible: true },
  { key: 'customer_name', label: '고객명', group: '예약 마스터', alwaysVisible: true },
  { key: 'reservation_date', label: '예약일', group: '예약 마스터', alwaysVisible: true },
  { key: 'customer_phone', label: '연락처', group: '예약 마스터' },
  { key: 'customer_email', label: '이메일', group: '예약 마스터' },
  { key: 'travel_start', label: '출발일', group: '예약 마스터' },
  { key: 'travel_end', label: '귀국일', group: '예약 마스터' },
  { key: 'adult_count', label: '성인', group: '예약 마스터' },
  { key: 'child_count', label: '소아', group: '예약 마스터' },
  { key: 'infant_count', label: '유아', group: '예약 마스터' },
  { key: 'status', label: '상태', group: '예약 마스터' },
  { key: 'source', label: '예약 경로', group: '예약 마스터' },
  { key: 'master_notes', label: '메모', group: '예약 마스터', alwaysVisible: true },
  { key: 'flight.airline', label: '항공사', group: '항공' },
  { key: 'flight.flight_number', label: '편명', group: '항공' },
  { key: 'flight.departure_airport', label: '출발공항', group: '항공' },
  { key: 'flight.arrival_airport', label: '도착공항', group: '항공' },
  { key: 'flight.departure_at', label: '출발일시', group: '항공' },
  { key: 'flight.arrival_at', label: '도착일시', group: '항공' },
  { key: 'flight.departure_raw', label: '출발 원본', group: '항공' },
  { key: 'flight.arrival_raw', label: '도착 원본', group: '항공' },
  { key: 'flight.passenger_name', label: '탑승자명', group: '항공' },
  { key: 'flight.seat_no', label: '좌석', group: '항공' },
  { key: 'flight.passenger_type', label: '구분', group: '항공' },
  { key: 'flight.total_payment', label: '총액 자동', group: '항공', readOnly: true, source: 'calculated' },
  { key: 'flight.base_fare', label: '항공운임', group: '항공' },
  { key: 'flight.fuel_surcharge', label: '유류할증료', group: '항공' },
  { key: 'flight.taxes', label: '공항세', group: '항공' },
  { key: 'car.rental_company', label: '업체', group: '렌트카' },
  { key: 'car.car_model', label: '차종', group: '렌트카' },
  { key: 'car.pickup_location', label: '인수지', group: '렌트카' },
  { key: 'car.return_location', label: '반납지', group: '렌트카' },
  { key: 'car.pickup_at', label: '인수일시', group: '렌트카' },
  { key: 'car.return_at', label: '반납일시', group: '렌트카' },
  { key: 'car.driver_name', label: '운전자', group: '렌트카' },
  { key: 'car.insurance_type', label: '보험', group: '렌트카' },
  { key: 'car.total_cost', label: '총액', group: '렌트카' },
  { key: 'hotel.hotel_name', label: '호텔명', group: '호텔' },
  { key: 'hotel.hotel_address', label: '주소', group: '호텔' },
  { key: 'hotel.room_type', label: '객실 타입', group: '호텔' },
  { key: 'hotel.room_count', label: '객실 수', group: '호텔' },
  { key: 'hotel.check_in', label: '체크인', group: '호텔' },
  { key: 'hotel.check_out', label: '체크아웃', group: '호텔' },
  { key: 'hotel.nights', label: '박', group: '호텔' },
  { key: 'hotel.guest_count', label: '투숙객', group: '호텔' },
  { key: 'hotel.confirmation_no', label: '확정번호', group: '호텔' },
  { key: 'hotel.total_cost', label: '총액 자동', group: '호텔', readOnly: true, source: 'calculated' },
  { key: 'hotel.nightly_rates', label: '일별요금', group: '호텔' },
  { key: 'payment.payment_date', label: '지불일', group: '결제' },
  { key: 'payment.amount', label: '고객지불', group: '결제' },
  { key: 'payment.payment_method', label: '지불수단', group: '결제' },
  { key: 'payment.cash_receipt_issue_no', label: '현금영수증번호', group: '결제' },
  { key: 'payment.cash_receipt_amount', label: '현금영수증금액', group: '결제' },
  { key: 'quote.has_cancel_or_change', label: '취소/변경', group: '정산 정보' },
  { key: 'quote.airline_cancel_fee', label: '에어카텔 취소수수료', group: '정산 정보', readOnly: true, source: 'calculated' },
  { key: 'quote.customer_cancel_fee', label: '고객 취소수수료', group: '정산 정보' },
  { key: 'quote.customer_refund', label: '고객환불', group: '정산 정보', readOnly: true, source: 'calculated' },
  { key: 'quote.post_refund_balance', label: '환불후차액', group: '정산 정보', readOnly: true, source: 'calculated' },
  { key: 'quote.misc', label: '기타금액', group: '정산 정보' },
  { key: 'quote.misc_note', label: '기타비고', group: '정산 정보' },
  { key: 'quote.refund_date', label: '환불일', group: '정산 정보' },
  { key: 'quote.refund_account', label: '환불계좌', group: '정산 정보' },
];

export const DEFAULT_HIDDEN_FIELDS = [
  'customer_phone', 'customer_email', 'travel_start', 'travel_end',
  'adult_count', 'child_count', 'infant_count', 'status', 'source',
  'flight.airline', 'flight.flight_number', 'flight.departure_airport', 'flight.arrival_airport',
  'flight.departure_at', 'flight.arrival_at', 'flight.departure_raw', 'flight.arrival_raw',
  'flight.passenger_name', 'flight.seat_no',
  'car.rental_company', 'car.car_model', 'car.pickup_location', 'car.return_location',
  'car.pickup_at', 'car.return_at', 'car.driver_name', 'car.insurance_type',
  'hotel.hotel_name', 'hotel.hotel_address', 'hotel.room_type', 'hotel.room_count',
  'hotel.check_in', 'hotel.check_out', 'hotel.nights', 'hotel.guest_count',
  'hotel.confirmation_no',
  'quote.has_cancel_or_change', 'quote.airline_cancel_fee', 'quote.customer_cancel_fee',
  'quote.customer_refund', 'quote.post_refund_balance', 'quote.misc', 'quote.misc_note',
  'quote.refund_date', 'quote.refund_account',
];
